import React, { useState } from 'react';
import Dashboard from './Dashboard';
import Projects from './Projects';
import Products from './Products';

const TABS = [
  { key: 'dashboard', label: 'Dashboard', Comp: Dashboard },
  { key: 'projects', label: 'Projects', Comp: Projects },
  { key: 'products', label: 'Products', Comp: Products },
];

export default function HomeHub() {
  const [tab, setTab] = useState('dashboard');
  const Active = TABS.find(t => t.key === tab).Comp;
  return (
    <div>
      <div className="tabs" style={{ marginBottom: 16 }}>
        {TABS.map(t => (
          <button key={t.key} className={`tab ${tab === t.key ? 'active' : ''}`} onClick={() => setTab(t.key)}>{t.label}</button>
        ))}
      </div>
      <Active />
    </div>
  );
}
